import * as React from 'react';

import CcmCampaignPaymentsPayoutsHeader from './header/CcmCampaignPaymentsPayoutsHeader';
import CcmCampaignPaymentsPayoutsList from './list/CcmCampaignPaymentsPayoutsList';

import './ccm-campaign-payments-with-data-payouts.scss';

import { Subcampaign } from 'types';

interface Props {
  subcampaigns: Array<Subcampaign>
}

const CcmCampaignPaymentsWithDataPayouts = ({
  subcampaigns
}: Props) => (
  <div className="ccm-campaign-payments-with-data-payouts">
    {subcampaigns.map((subcampaign, index) => (
      <div
        className="ccm-campaign-payments-with-data-payouts__per-creator-container"
        key={`${index}-${subcampaign.id}`}
      >
        <CcmCampaignPaymentsPayoutsHeader
          campaignId={subcampaign.campaignId}
          subcampaign={subcampaign}
        />
        <CcmCampaignPaymentsPayoutsList
          campaignId={subcampaign.campaignId}
          subcampaign={subcampaign}
        />
      </div>
    ))}
  </div>
);

export default CcmCampaignPaymentsWithDataPayouts;
